module.exports = __webpack_public_path__ + "static/media/data-sheets.c3b92367.svg";